import Vue from 'vue'
import Heading from '@/components/core/Heading'
import Section from '@/components/core/Section'
import Subheading from '@/components/core/Subheading'
import Text from '@/components/core/Text'

Vue.component('CoreHeading', Heading)
Vue.component('CoreSection', Section)
Vue.component('CoreSubheading', Subheading)
Vue.component('CoreText', Text)
